import { memo } from "react";
import { Stack } from "@mui/material";
import type { RequesterMode } from "../../booking/types";
import type { TeleconsultoriaViewMode } from "../../hooks/useTeleconsultoriaViewAccess";
import { AffiliateProviderBanner } from "./AffiliateProviderBanner";
import { AffiliateTeleconsultoriasHub } from "./AffiliateTeleconsultoriasHub";

/**
 * Tela da AFILIADA, por aba da página:
 * - Profissional: marca para si (solicitante = o próprio usuário);
 * - Clínica: marca para qualquer profissional da clínica e filtra as marcadas por ele.
 * Um componente só: marcadas em foco + "Marcar teleconsultoria" sob demanda (painel).
 * Sem disponibilidade e sem afiliações (são exclusivas da prestadora).
 */
export const AffiliateTeleconsultoriaPanel = memo(function AffiliateTeleconsultoriaPanel({
  providerName,
  view,
}: {
  providerName: string;
  view: TeleconsultoriaViewMode;
}) {
  const requesterMode: RequesterMode = view === "clinic" ? "choose" : "self";

  return (
    <Stack spacing={3} width="100%">
      <AffiliateProviderBanner providerName={providerName} />
      {/* key: trocar de aba começa a lista de novo (filtros de outra visão não vazam). */}
      <AffiliateTeleconsultoriasHub key={requesterMode} providerName={providerName} requesterMode={requesterMode} />
    </Stack>
  );
});
